<template>
  <header class="header">
    <div>
      <el-input
        v-if="isEdit"
        ref="editName"
        v-model="nodeData.nodeName"
        @blur="changeEditState(false)"
        @keyup.enter.native="changeEditState(false)"
      />
      <span v-else @click="changeEditState(nodeData.nodeName ? true : false)">
        <span v-if="nodeData.type !== 3">{{ $t(nodeI18n.get(nodeData.type)) }}</span>
        <span v-else>{{ nodeData.nodeName }} <i class="el-icon-edit" /></span>
      </span>
    </div>
    <!-- 关闭 -->
    <div class="chose-drawer" @click="$emit('close')">
      <i class="el-icon-close" />
    </div>
  </header>
</template>

<script>
import { nodeI18n } from '../examples'

export default {
  props: {
    // 当前节点数据
    nodeData: {
      default: () => ({}),
      type: Object
    }
  },
  data() {
    return {
      // title编辑状态
      isEdit: false,
      // 标题名称
      nodeI18n
    }
  },
  methods: {
    // 名称编辑
    changeEditState(state) {
      this.isEdit = state
      if (state) this.$nextTick(() => this.$refs.editName.focus())
    }
  }
}
</script>

<style></style>
